import PropTypes from 'prop-types';
import { useState } from 'react';

import { useUserContext } from '@context/UserContent';
import { DateField, FormAlert, Modal } from '@components';
import { extendCampaign } from '@apis/Campaign';

import sty from './extendCampaign.module.scss';

function ExtendCampaignModal(props) {
  const {
    campaignId,
    closeFn,
    closeTxt,
    onCampaignExtended,
    saveTxt,
    msg,
    center,
    className,
    startDate,
  } = props;
  const { user } = useUserContext();
  // DateField works in 'yyyy-MM-dd' strings, which is exactly what the API wants.
  const [endDate, setEndDate] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Floor the dates at the campaign's start, or today if it has already started,
  // so an extended end date can't land before the campaign begins (a launched
  // campaign whose start is still in the future can be extended).
  const today = new Date();
  const start = startDate ? new Date(startDate) : null;
  const minEnd = start && start > today ? start : today;

  async function submit() {
    if (!endDate || !expiryDate) {
      setError('Please choose valid expiry dates');
      return;
    }
    setLoading(true);
    const res = await extendCampaign(
      user.accessToken,
      { endDate, offerEndDate: expiryDate },
      campaignId,
    );
    setLoading(false);
    if (res.status) {
      onCampaignExtended(res.data);
    } else {
      setError(res.message);
    }
  }

  return (
    <Modal
      className={className}
      title={msg}
      center={center}
      onClose={closeFn}
      closeOnBackdrop={false}
      secondaryAction={{ label: closeTxt, onClick: closeFn }}
      primaryAction={{ label: saveTxt, onClick: submit, loading: isLoading }}
    >
      <div className={sty.fields}>
        <div className={sty.field}>
          {/* eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */}
          <label className={sty.label}>Campaign End Date</label>
          <DateField value={endDate} onChange={setEndDate} minDate={minEnd} />
        </div>
        <div className={sty.field}>
          {/* eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */}
          <label className={sty.label}>Reward Expiry Date</label>
          <DateField
            value={expiryDate}
            onChange={setExpiryDate}
            minDate={endDate ? new Date(endDate) : minEnd}
          />
        </div>
      </div>
      <FormAlert message={error} className={sty.alert} />
    </Modal>
  );
}

ExtendCampaignModal.propTypes = {
  campaignId: PropTypes.string,
  closeFn: PropTypes.func,
  closeTxt: PropTypes.string,
  onCampaignExtended: PropTypes.func,
  saveTxt: PropTypes.string,
  msg: PropTypes.string,
  center: PropTypes.bool,
  className: PropTypes.string,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
};

export default ExtendCampaignModal;
